import { SellerQuery } from '../queries/Seller.gql'

export const CUSTOM_CMS_SELLER_TYPE_MESSIKA_STORE = 'messika'
export const CUSTOM_CMS_SELLER_TYPE_RESELLERS = 'retailer'

export type CustomCmsSellerType =
  | typeof CUSTOM_CMS_SELLER_TYPE_MESSIKA_STORE
  | typeof CUSTOM_CMS_SELLER_TYPE_RESELLERS

export type CustomCmsSeller = {
  id: number
  name: string
  description: string
  type: CustomCmsSellerType
  longitude: string
  latitude: string
  isActive: boolean
  phone: string | null
  address: string
  street: string
  city: string
  url: string
  postCode: string | null
  categories: Array<string>
  country: string
  openingHours: string
  nameCountry?: string
  image?: string
  showSchedule?: boolean
  isMessika: boolean
  alternates?: {
    url: string | null
    language_code: string | null
  }[]
}

export type CmsSellerFiltersRadius = {
  lat?: number
  lng?: number
  value?: number
}

export type CmsSellerFilters = {
  city?: string
  country?: string
  radius?: CmsSellerFiltersRadius
  type?: CustomCmsSellerType
  categories?: Array<string>
}

export function prepareSeller(data: SellerQuery | null | undefined): CustomCmsSeller | null {
  if (!data) {
    return null
  }

  const seller = data.seller

  if (!seller) {
    return null
  }

  const customSeller: CustomCmsSeller = {
    id: seller.id || 0,
    name: seller.name || '',
    description: seller.description || '',
    type: seller.type as CustomCmsSellerType,
    longitude: seller.longitude || '',
    latitude: seller.latitude || '',
    isActive: false,
    phone: seller.phone || '',
    address: seller.address || '',
    street: seller.street?.[0] || '',
    city: seller.city || '',
    country: seller.name_country || '',
    url: seller.url || '',
    postCode: seller.postCode || '',
    openingHours: seller.schedule?.openingHours || '',
    categories: [],
    isMessika: seller.is_messika ?? false,
    alternates: [],
    image: seller?.image ?? undefined
  }

  seller.categories?.forEach((category) => {
    if (category) {
      customSeller.categories.push(category)
    }
  })

  seller.alternates?.forEach((alternate) => {
    if (customSeller.alternates && alternate) {
      customSeller.alternates.push({
        url: alternate.url ?? '',
        language_code: alternate.language_code ?? '',
      })
    }
  })

  return customSeller
}
